import React, {useState} from 'react'
import {Input, notification} from 'antd'
import {Redirect} from 'react-router-dom'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'

const markAssetsForCorrectionMutation = gql`
  mutation MarkAssetsForCorrection($input: AssetsForCorrectionInput!) {
    MarkAssetsForCorrection(input: $input) {
      product {
        id
        state
      }
    }
  }
`

const ConfirmPhotos = ({match, selectedPhotos, stateReducer}) => {
  const [redirectToProduct, setRedirectToProduct] = useState(false)

  if (redirectToProduct) {
    return <Redirect to={`/oppdrag/${match.params.estateId}/produkt/${match.params.productId}`} />
  }

  return (
    <div className="product-correction confirm-photos">
      <Heading level={2}>Hva skyldes korrigeringen?</Heading>

      <div className="selected-photos">
        {selectedPhotos.map((photo) => (
          <div key={photo.id} className="selected-photo">
            <div className="thumb">
              <img src={photo.image.thumbUrl} alt="" />
            </div>
            <div className="comment">
              <label>
                Kommentar
                <Input.TextArea
                  value={photo.comment}
                  autosize={{minRows: 2, maxRows: 4}}
                  onChange={(e) => {
                    stateReducer({type: 'updatePhotoComment', photo, comment: e.target.value})
                  }}
                />
              </label>
            </div>
          </div>
        ))}
      </div>

      <div className="actions">
        <Button
          secondary
          type="navigation"
          onClick={() => stateReducer({type: 'setStep', step: 'select'})}
        >
          Tilbake
        </Button>

        <Mutation
          mutation={markAssetsForCorrectionMutation}
          onCompleted={() => {
            notification['success']({
              message: 'Sendt til korrigering',
              description: 'Bildene er nå sendt til korrigering.',
            })
            setRedirectToProduct(true)
          }}
          onError={() => {
            notification['error']({
              message: 'Korrigering feilet',
              description: 'Bildene kunne ikke korrigeres grunnet en feil. Forsøk på nytt senere.',
            })
          }}
        >
          {(createCorrection, {loading}) => (
            <Button
              type="action"
              loading={loading}
              disabled={loading}
              onClick={() => {
                createCorrection({
                  variables: {
                    input: {
                      productId: match.params.productId,
                      assets: selectedPhotos.map((photo) => ({
                        id: photo.id,
                        comment: photo.comment,
                      })),
                    }
                  }
                })
              }}
            >
              Send til korrigering
            </Button>
          )}
        </Mutation>
      </div>
    </div>
  )
}

export default ConfirmPhotos
